export const calculateRemainingTime = (endDate: Date) => {
  const now = new Date();
  const timeLeft = (endDate.getTime() - now.getTime()) / 1000;
  return Math.max(0, Math.floor(timeLeft));
};
